import React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./tabs.module.css";

const Tabs_ = ({
  TabList_ = [],
  TabContent_ = [],
  selectedIndex = 0,
  setSelectedIndex = () => {},
  TabStyleOverride = null,
  TabListStyleOverride = null,
  TabPanelStyleOverride = null,
  disabledTabs = false,
  ...dataTableProps
}) => {
  const getTabList = () => {
    const Tabss = TabList_?.map((e) => {
      return <Tab disabled={disabledTabs}>{e?.label}</Tab>;
    });

    if (TabListStyleOverride) {
      return <TabList className={TabListStyleOverride}>{Tabss}</TabList>;
    } else {
      return <TabList>{Tabss}</TabList>;
    }
  };

  return (
    <Tabs
      className={TabStyleOverride}
      selectedIndex={selectedIndex}
      onSelect={setSelectedIndex}
    >
      {getTabList()}
      {TabContent_?.map((e) => {
        return (
          <TabPanel className={TabPanelStyleOverride}>{e?.content}</TabPanel>
        );
      })}
    </Tabs>
  );
};

export default React.memo(Tabs_);
